
export default {
  computed: {
    isSmallPrinter() {
      return this.$ls.get("printer-type", "md") == "sm";
    },
    // getEmptySpaces() {
    //   const emptySpaces = this.$ls.get("empty-space", 0);
    //   return 10 * emptySpaces;
    // },
    getPrintWidth() {
      const reducer = Number(this.$ls.get("print-width-reduce", 0));
      const pixelsPerInch = 86;
      const printScale = this.isSmallPrinter ? 1.8 : 2.8;
      const printWidth = pixelsPerInch * printScale;
      return printWidth - reducer;
    }
  }
};
